// Responsive breakpoint definitions for DIDI web application

export const breakpoints = {
  mobile: 320,
  tablet: 768,
  desktop: 1024,
  wide: 1440,
} as const;

// Type for breakpoint keys
export type BreakpointKey = keyof typeof breakpoints;

// Media query helpers
export const media = {
  mobile: `@media (min-width: ${breakpoints.mobile}px)`,
  tablet: `@media (min-width: ${breakpoints.tablet}px)`,
  desktop: `@media (min-width: ${breakpoints.desktop}px)`,
  wide: `@media (min-width: ${breakpoints.wide}px)`,

  // Max-width variants for mobile-first approach
  maxMobile: `@media (max-width: ${breakpoints.tablet - 1}px)`,
  maxTablet: `@media (max-width: ${breakpoints.desktop - 1}px)`,
  maxDesktop: `@media (max-width: ${breakpoints.wide - 1}px)`,
} as const;

// Helper function to generate custom media queries
export const mediaQuery = (minWidth: number, maxWidth?: number): string => {
  if (maxWidth) {
    return `@media (min-width: ${minWidth}px) and (max-width: ${maxWidth}px)`;
  }
  return `@media (min-width: ${minWidth}px)`;
};
